import React from "react";

export const ArrowDown = ({ fill, className }) => {
  const colorVariants = {
    gray: "stroke-gray-2500 fill-gray-2500",
    grayHover: "stroke-gray-2700 fill-gray-2700",
    purpleHover: "stroke-purple-1500 fill-purple-2700",
    white: "stroke-white fill-white",
  };
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorVariants[fill]} ${className}`}
    >
      <path
        d="M3.48479 4.10154L2.42796 4.10154C2.33635 4.10154 2.28577 4.20682 2.34182 4.27791L7.15569 10.4412C7.19641 10.4936 7.24856 10.5359 7.30815 10.5651C7.36774 10.5942 7.4332 10.6094 7.49954 10.6094C7.56587 10.6094 7.63133 10.5942 7.69093 10.5651C7.75052 10.5359 7.80266 10.4936 7.84338 10.4412L12.6573 4.27791C12.7133 4.20545 12.6627 4.10154 12.5711 4.10154L11.5143 4.10154C11.4473 4.10154 11.383 4.13299 11.342 4.18494L7.50022 9.10682L3.65706 4.18494C3.61604 4.13299 3.55178 4.10154 3.48479 4.10154Z"
        fill="#34344B"
        fill-opacity="0.7"
      />
    </svg>
  );
};

export const PricingPageArrow = ({ fill }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.50345 10.4102L13.7884 10.4102L7.63255 15.7539C7.53411 15.84 7.59387 16 7.72395 16L9.27962 16C9.34817 16 9.41321 15.9754 9.46419 15.9314L16.107 10.1676C16.1678 10.1148 16.2166 10.0496 16.25 9.9764C16.2835 9.90316 16.3008 9.82358 16.3008 9.74307C16.3008 9.66255 16.2835 9.58298 16.25 9.50973C16.2166 9.43649 16.1678 9.37129 16.107 9.31855L9.42551 3.51953C9.39915 3.49668 9.36751 3.48438 9.33411 3.48438L7.72571 3.48438C7.59563 3.48438 7.53587 3.64609 7.6343 3.73047L13.7884 9.07422L3.50345 9.07422C3.4261 9.07422 3.36282 9.1375 3.36282 9.21484L3.36282 10.2695C3.36282 10.3469 3.4261 10.4102 3.50345 10.4102Z"
        fill={fill}
      />
    </svg>
  );
};
